export default "__VITE_ASSET__c320c30c__"